/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( document ).on( 'click', '.llgq-quoter-submit', function() {
        $( '.gform_page_footer button[type="submit"]' ).trigger( 'click' );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( currentPage == $( '.gform_page' ).length ) {
          $( '.llgq-quoter-next' ).addClass( 'is-inactive' );
          $( '.llgq-quoter-submit' ).removeClass( 'is-inactive' );
        } else {
          $( '.llgq-quoter-next' ).removeClass( 'is-inactive' );
          $( '.llgq-quoter-submit' ).addClass( 'is-inactive' );
        }
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.multipage-form__page--form' ).removeClass( 'is-active' );
        $( '.multipage-form__page--confirmation' ).addClass( 'is-active' );
      } );

      $( '.multipage-form__page--intro' ).on( 'toggleAfter', function() {
        $( 'html, body' ).animate( {scrollTop: 0}, 0 );
      } );

      if ( $( '.multipage-form' ).attr( 'data-focus' ) !== '' ) {
        const focusPage = parseInt( $( '.multipage-form' ).attr( 'data-focus' ) );
        $( '.multipage-form .gform_wrapper' ).addClass( 'opacity-0' );
        $( '.gform_page:first-child .gfield:first-child .gchoice:nth-child(' + focusPage + ') input' ).prop( 'checked', true ).trigger( 'change' );

        setTimeout( function() {
          $( '.llgq-quoter-next' ).trigger( 'click' );
        }, 250 );
      }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if (
          $( '.multipage-form' ).attr( 'data-focus' ) !== '' &&
          $( '.multipage-form .gform_wrapper' ).hasClass( 'opacity-0' ) &&
          currentPage !== 1
        ) {
          $( '.multipage-form .gform_wrapper' ).removeClass( 'opacity-0' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
